import Api, { formatDate } from 'api/api';

class TransactionItemApi {
    list({category, year, month}) {
        return Api.get('/transaction_items', {
            params: {
                category,
                year,
                month,
            }
        }).then(response => response.data.map(tx => ({...tx, amount: parseInt(tx.amount, 10)})))
    }

    post({date, amount, category, description}) {
        return Api.post('/transaction_items', {
            date: formatDate(date), amount, category, description,
        });
    }

    put(id, {date, amount, description,}) {
        return Api.put(`/transaction_items/${id}`, {
            date: formatDate(date), amount, description
        });
    }

    delete(id) {
        return Api.delete(`/transaction_items/${id}`);
    }
}

export default new TransactionItemApi();


// WEBPACK FOOTER //
// ./src/api/transaction-item.js